import styled from 'styled-components';
import { MediaQuery, Size } from '../../constant/breakpoint.ts';

export const BGColor = styled('div')({
    backgroundColor: '#EDEDED',
})

export const Wrapper = styled('div')({
    height: 'auto',
    backgroundColor: '#EDEDED',

    width: '1123px',
    margin: '0 auto',
    position: 'relative',
    zIndex: '3',
    paddingBottom: '160px',
    paddingTop: '48px',

    [MediaQuery[Size.XL]]: {
        width: '980px',
    },
    [MediaQuery[Size.LG]]: {
        width: '740px',
        paddingBottom: '400px'
    },
    [MediaQuery[Size.MD]]: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        width: "auto",
        paddingLeft: '40px',
        paddingRight: '40px',
        paddingBottom: '0px'
    },
    [MediaQuery[Size.SM]]: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        width: "auto",
        paddingLeft: '20px',
        paddingRight: '20px',
    },
})

export const Section = styled('div')({
    height: 'auto',
})

export const ImageDiv = styled('img')({
    zIndex: '3',
    position: 'relative',
    width: 'auto',
    [MediaQuery[Size.XL]]: {
        width: "360px"
    },
    [MediaQuery[Size.LG]]: {
        width: "312px"
    },

    [MediaQuery[Size.MD]]: {
        width: "411px"
    },
    [MediaQuery[Size.SM]]: {
        width: "300px"
    },
    '@media (max-width: 440px)' : {
        width: '340px'
    },
    '@media (max-width: 360px)' : {
        width: "280px"
    },
    '@media (max-width: 300px)' : {
        width: "240px"
    },
})

export const NameDivBox = styled('div')({
    position: "absolute",
    left: '464px',
    top: '0%',

    backgroundColor: "#CCA25E",
    color: "white",
    borderRadius: "22px",
    fontSize: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '12px 24px 12px 24px',
    fontWeight: '600',
    zIndex: '2',

    [MediaQuery[Size.XL]]: {
        left: '404px',
        fontSize: '28px',
    },

    [MediaQuery[Size.LG]]: {
        left: '316px',
        fontSize: '20px',
    },

    [MediaQuery[Size.MD]]: {
        position: "static",
        fontSize: '24px',
        marginTop: '0px',
        width: '80%',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
})

export const BoxImage = styled('div')({
    width: '100%',
    position: 'relative',
    [MediaQuery[Size.MD]]: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
})

export const ButtonContainer = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: '32px',
    [MediaQuery[Size.XL]]: {
        marginTop: '20px'
    },
    '@media (max-width: 440px)' : {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
    },
})


export const SendEmailButton = styled('div')({
    width: "32%",
    height: "auto",
    borderRadius: "45px",
    backgroundColor: "#CCA25E",
    display: "flex",
    alignItems: 'center',
    justifyContent: 'center',
    color: "white",
    marginTop: "20px",
    padding: "8px",

    [MediaQuery[Size.XL]]: {
        width: "100%"
    },
    [MediaQuery[Size.MD]]: {
        width: "50%"
    },
    '@media (max-width: 440px)' : {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
    },
})

export const LinkedinButton = styled('div')({
    width: "32%",
    height: "auto",
    borderRadius: "45px",
    display: "flex",
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: "#D9D9D9",
    color: "black",
    padding: "8px",
    marginTop: "20px",
    marginLeft: "20px",
    cursor: 'pointer',
    [MediaQuery[Size.XL]]: {
        width: "100%"
    },
    [MediaQuery[Size.MD]]: {
        marginLeft: "20px",
        width: "50%"
    },
    '@media (max-width: 440px)' : {
        marginLeft: "0px",
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
    },
})

export const BodyBox = styled('div')(({
    backgroundColor,
}) => ({
    position: "absolute",
    left: '218px',
    top: '40px',
    padding: '64px 48px 96px 256px',

    backgroundColor: backgroundColor,
    color: "white",
    borderRadius: "30px",
    width: "908px",
    zIndex: '1',
    height: 'auto',

    [MediaQuery[Size.XL]]: {
        left: '152px',
        width: '828px',
        padding: '48px 32px 24px 256px',
    },

    [MediaQuery[Size.LG]]: {
        left: '80px',
        width: '628px',
        padding: '48px 32px 24px 256px',
    },

    [MediaQuery[Size.MD]]: {
        position: "relative",
        left: '0px',
        top: '-130px',
        padding: '24px 24px 24px 24px',
        width: 'auto'
    },
}));

export const Title = styled('div')({
    fontSize: '22px',
    fontWeight: '600',
    fontStyle: 'italic',
    [MediaQuery[Size.MD]]: {
        marginTop: '120px',
        textAlign: 'left',
    },
})

export const Description = styled('div')({
    fontSize: '20px',
    fontWeight: '300',
    marginTop: '24px',
    paddingRight: '64px',
    overflowY: 'auto',
    maxHeight: '220px',
    whiteSpace: 'pre-line',
    [MediaQuery[Size.MD]]: {
        textAlign: 'left',
        paddingRight: '0px',
    },
})

export const WhiteCircle = styled('div')({
    position: "absolute",
    left: '316px',
    top: '376px',

    height: '111px',
    width: '111px',
    backgroundColor: 'white',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 4,

    [MediaQuery[Size.XL]]: {
        left: '264px',
        top: '328px',
    },

    [MediaQuery[Size.LG]]: {
        left: '216px',
        top: '282px',
    },

    [MediaQuery[Size.MD]]: {
        top: '334px',
        left: '67.5%',
    },
    // '@media (max-width: 700px)' : {
    //     top: '340px',
    //     left: 'auto',
    //     right: '140px' 
    // },
    // '@media (max-width: 670px)' : {
    //     top: '340px',
    //     left: 'auto',
    //     right: '130px' 
    // },
    [MediaQuery[Size.SM]]: {
        height: '91px',
        width: '91px',

        top: '232px',
        left: '64%',
    },
    // '@media (max-width: 560px)' : {
    //     left: 'auto',
    //     top: '280px',
    //     right: '110px' 
    // },
    // '@media (max-width: 480px)' : {
    //     left: 'auto',
    //     top: '240px',
    //     right: '100px' 
    // },
    '@media (max-width: 440px)' : {
        left: 'auto',
        top: '272px',
        right: '8px' 
    },
    '@media (max-width: 420px)' : {
        left: 'auto',
        top: '260px',
        right: '8px' 
    },
    '@media (max-width: 400px)' : {
        left: 'auto',
        top: '272px',
        right: '-12px'
    },
    '@media (max-width: 360px)' : {
        left: 'auto',
        top: '208px',
        right: '0px'
    },
    '@media (max-width: 330px)' : {
        left: 'auto',
        top: '208px',
        right: '-12px'
    },
    '@media (max-width: 300px)' : {
        left: 'auto',
        top: '172px',
        right: '0px'
    },
    // '@media (max-width: 370px)' : {
    //     left: 'auto',
    //     top: '160px',
    //     right: '64px'  
    // },
    // '@media (max-width: 340px)' : {
    //     left: 'auto',
    //     top: '150px',
    //     right: '52px' 
    // },
    // '@media (max-width: 310px)' : {
    //     left: 'auto',
    //     top: '60px',
    //     right: '40px' 
    // },
})

export const YellowCircle = styled('div')({
    height: '77px',
    width: '77px',
    backgroundColor: '#CCA25E',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [MediaQuery[Size.SM]]: {
        height: '66px',
        width: '66px',
    },
})

export const Associate = styled('div')({
    margin: 'auto',
    width: '85%',
    paddingTop: '40px',
    paddingBottom: '40px',
    marginBottom: '12px',

    [MediaQuery[Size.NAV]]: {
        width: '90%',
    },
    [MediaQuery[Size.MD]]: {
        width: '92%',
    }
})

export const AssociateBody = styled('div')({
    marginTop: '20px',
    backgroundColor: '#EDEDED',
    borderRadius: '20px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    paddingTop: '32px',
    paddingBottom: '32px',
    [MediaQuery[Size.MD]]: {
        paddingLeft: '10px',
        paddingRight: '10px',
        flexDirection: 'column',

        paddingTop: '32px',
        paddingBottom: '20px',

        textAlign: 'center',
    }
})

export const AssociateTitle = styled('div')({
    fontWeight: 600,
    fontSize: 28
})

export const AssociateName = styled('div')({
    color: '#6F5649',
    fontWeight: 600,
    fontSize: 24,
    [MediaQuery[Size.MD]]: {
        paddingBottom: '12px'
    }
})
